// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { ParagraphComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import { FINANCIAL_DATA_COMPONENT_TITLE_PROPS } from './constants/financial-data-title.constants';
import { FinancialDataTitleComponentType } from './types/financial-data-title.component.type';

const FinancialDataTitle = ({
  title,
}: FinancialDataTitleComponentType): React.JSX.Element => (
    <ParagraphComponent {...FINANCIAL_DATA_COMPONENT_TITLE_PROPS}>
        <FormattedMessage id={title} />
    </ParagraphComponent>
);

export { FinancialDataTitle };
